export default "__VITE_PUBLIC_ASSET__722a0f68__"